import React from 'react';
import {useSearchParams} from "react-router-dom";
import AppClient from "./Client/AppClient";
import AppConseiller from "./Conseiller/AppConseiller";

const App = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const searchType = searchParams.get('type') || '';
    const searchEtablissement = searchParams.get('etablissement') || '';
    let params = (new URL(document.location)).searchParams;
    console.log(params)
    return (
        <div className={"App"}>
            {searchType === "conseiller" && <AppConseiller etablissement={searchEtablissement}/>}
            {searchType === "client" && <AppClient etablissement={searchEtablissement}/>}
        </div>
    );
};


export default App;